export const PRIME_LANDING_PAGE_URL = "prime";
